
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import ScrollAnimation from './ScrollAnimation';

const CTASection = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  
  return (
    <section className="py-20 md:py-28 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <ScrollAnimation>
          <div className="text-center space-y-6">
            <h2 className="heading-lg" style={{ textWrap: 'balance' }}>
              {t('cta.title')}
            </h2>
            <p className="body-md text-muted-foreground max-w-xl mx-auto" style={{ textWrap: 'pretty' }}>
              {t('cta.description')}
            </p>
            <div className="pt-2">
              <Button 
                size="lg" 
                className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-3.5 text-base font-medium group active:scale-[0.97] transition-all duration-200 shadow-md hover:shadow-lg"
                onClick={() => navigate('/dashboard')}
                aria-label="Start using DCFlow dashboard now"
              >
                {t('cta.button')}
                <ArrowRight size={17} className="ml-2 group-hover:translate-x-0.5 transition-transform duration-200" />
              </Button>
            </div>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
};

export default CTASection;
